import React, { ReactElement } from 'react';

import { PRODUCTS_PROJECT_CONFIG } from '~/constants/products';
import router from '~/core/router';
import { sidebar } from '~/core/sidebar';
import { BlackFridayRoute } from '~/modules/black-friday';
import { ReactComponent as DiscountIcon } from '~/modules/black-friday/assets/discount.svg';
import { BlackFridaySidebarKey } from '~/modules/black-friday/constants';

router.addPrivateRoutes([BlackFridayRoute]);

sidebar.addItems({
  a: [
    {
      order: 6,
      key: BlackFridaySidebarKey,
      path: BlackFridayRoute.path,
      getTitle: (t) => t('black_friday:sidebar_title', 'Black Friday Deal'),
      Icon: (): ReactElement => {
        return <DiscountIcon />;
      },
      checkAvailability: (profile): boolean => {
        return (
          profile.user_product.id !==
            PRODUCTS_PROJECT_CONFIG.ANNUAL_SUB_OFFER_ID &&
          !profile.is_stripe_user
        );
      },
    },
  ],
});
